// 线上鬼市相关路由
export default {
  routes: [
    // 线上鬼市商家报名页、商品选择页
    {
      path: '/(\\s*)nightmarket(\\d*)/(\\s*)apply(\\d*)',
      name: 'nightmarketApply',
      meta: {
        title: '报名页'
      },
      component: () =>
        import(/* webpackChunkName: "nightmarketApply" */ '../views/nightMarket/apply/index.vue')
    },
    // 鬼市首页
    {
      path: '/(\\s*)nightmarket(\\d*)/(\\s*)home(\\d*)',
      name: 'nightmarketHome',
      meta: {
        title: '转转真好玩'
      },
      component: () =>
        import(/* webpackChunkName: "nightmarketHome" */ '../views/nightMarket/home/index.vue')
    },
    // 鬼市商品页
    {
      path: '/(\\s*)nightmarket(\\d*)/(\\s*)notice(\\d*)',
      name: 'nightmarketNotice',
      meta: {
        title: '转转真好玩'
      },
      component: () =>
        import(/* webpackChunkName: "nightmarketNotice" */ '../views/nightMarket/notice/index.vue')
    },
    // 报名填写页
    {
      path: '/(\\s*)nightmarket(\\d*)/(\\s*)applyform(\\d*)',
      name: 'nightmarketApplyform',
      meta: {
        title: '报名'
      },
      component: () =>
        import(
          /* webpackChunkName: "nightmarketApplyform" */ '../views/nightMarket/applyform/index.vue'
        )
    }
  ]
}
